module.exports = __webpack_public_path__ + "1c219e46e03e57be9ba8ef9f6690c30a.png";